import React, { useEffect, useRef, useState, useCallback } from "react";
import { ListSkeleton } from "../../skeletons/List";
import { AuthHelper } from "../../controllers/AuthHelper";
import FloatingActionButtons from "../../components/Fab";
import RoomForm from "../../components/RoomForm";
import { Checkbox, IconButton, Box, Typography, Drawer } from "@mui/material";
import { Delete } from "@mui/icons-material";
import { register } from "swiper/element/bundle";
import { ServerConfig } from "../../../connectors/Config";

register();




const SingleCourse = React.memo(({ course, rooms, assignCourseToRoom, refreshRooms, onEdit }) => (
  <div style={{ maxWidth: 400, minHeight: 800, padding: "0 120px 48px" }}>
    <h2 style={{ textAlign: "left" }}>{course["nome corso"]}</h2>
    <div>
      {rooms.map((room) => {
        const assigned = room.assignments?.some(x => x.course === course["id"]);
        return (
          <div key={room.id} style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <Checkbox
              checked={!!assigned}
              onChange={() => assignCourseToRoom(course["id"], room.id)}
            />
            <h5 style={{ flex: 1, cursor: "pointer" }} onClick={() => onEdit(room)}>
              {room.name}
            </h5>
            <IconButton
              onClick={async () => {
                try {
                  await fetch(`${ServerConfig.AWS.Serverless.API_BASE_URL_2}/rooms/${room.id}`, { method: "DELETE" });
                  refreshRooms();
                } catch {
                  alert("Errore server");
                }
              }}
            >
              <Delete color="error" />
            </IconButton>
          </div>
        );
      })}
    </div>
  </div>
));

const ListAule = () => {
  const [rooms, setRooms] = useState([]);
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [drawerTitle, setDrawerTitle] = useState("");
  const [drawerData, setDrawerData] = useState(null);
  const swiperRef = useRef(null);

  // 🔹 Recupera l'utente corrente
  const getCurrentUser = useCallback(async () => {
    const apiKey = localStorage.getItem("cruddy-apiKey");
    const subCurrent = (await AuthHelper.getUserFromIdToken(apiKey)).Username;
    return subCurrent;
  }, []);

  // 🔹 Ottiene le aule dell'utente corrente
  const getRooms = useCallback(async () => {
    const currentUser = await getCurrentUser();
    const res = await (await fetch(`${ServerConfig.AWS.Serverless.API_BASE_URL_1}/aule/${currentUser}`)).json();
    setRooms(Array.isArray(res) ? res : []);
    setLoading(false);
  }, [getCurrentUser]);

  // 🔹 Ottiene la lista dei corsi
  const fetchCourses = useCallback(async () => {
    const res = await (await fetch(`${ServerConfig.AWS.Serverless.API_BASE_URL_1}/certificates`)).json();
    setCourses(Array.isArray(res) ? res : []);
  }, []);

  // 🔹 Assegna un corso a un'aula
  const assignCourseToRoom = useCallback(
    async (courseId, roomId) => {
      await fetch(`${ServerConfig.AWS.Serverless.API_BASE_URL_1}/rooms/assign/${roomId}`, {
        method: "PUT",
        body: JSON.stringify({ course: courseId, rooms }),
        headers: { "Content-Type": "application/json" },
      });
      getRooms();
    },
    [rooms, getRooms]
  );

  // 🔹 Crea nuova aula
  const handleCreate = useCallback(async () => {
    const currentUser = await getCurrentUser();
    setDrawerTitle("Crea Aula");
    setDrawerData({ initialData: null, assigned: currentUser });
    setDrawerOpen(true);
  }, [getCurrentUser]);

  // 🔹 Modifica aula esistente
  const handleEdit = useCallback(async (room) => {
    const currentUser = await getCurrentUser();
    setDrawerTitle("Modifica Aula");
    setDrawerData({ initialData: room, assigned: currentUser });
    setDrawerOpen(true);
  }, [getCurrentUser]);

  useEffect(() => {
    getRooms();
    fetchCourses();
  }, [getRooms, fetchCourses]);

  return (
    <>
      {loading && <ListSkeleton />}
      {!loading && (
        <swiper-container slides-per-view="3" ref={swiperRef} virtual="true" navigation="true" style={{ paddingBottom: 320 }}>
          {courses.map((course) => (
            <swiper-slide key={course.id}>
              <SingleCourse
                course={course}
                rooms={rooms}
                assignCourseToRoom={assignCourseToRoom}
                refreshRooms={getRooms}
                onEdit={handleEdit}
              />
            </swiper-slide>
          ))}
        </swiper-container>
      )}

      <Drawer anchor="right" open={drawerOpen} onClose={() => setDrawerOpen(false)}>
        <Box sx={{ width: 600, height: "100vh", display: "flex", flexDirection: "column" }}>
          <Box
            sx={{
              background: "linear-gradient(to bottom right, #9DCEE2, #7256CB)",
              color: "#fff",
              height: "80px",
              display: "flex",
              alignItems: "center",
              px: 2,
            }}
          >
            <Typography variant="h6">{drawerTitle}</Typography>
          </Box>
          <Box sx={{ flex: 1, overflowY: "auto", bgcolor: "#fafafa", p: 2 }}>
            {drawerOpen && (
              <RoomForm
                initialData={drawerData?.initialData}
                assigned={drawerData?.assigned}
                onSubmit={getRooms}
                onClose={() => setDrawerOpen(false)}
              />
            )}
          </Box>
        </Box>
      </Drawer>

      <FloatingActionButtons onClick={handleCreate} />
    </>
  );
};

export default ListAule;
